module.exports = __webpack_public_path__ + "static/media/example_benefit_card.a5075646.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/example_benefit_card.png
// module id = 944
// module chunks = 0